import { Controller } from "@hotwired/stimulus"

// Toggle elements' visibility with a class name. Initialise visibility with a
// `visibile` value. Use a "sticky" target to let elements show once and
// remain visible.
// Actions:
//   toggle - invert the visibility of all "togglee" targets
//   switch - show only the target items with a switch attribute containing
//            the value of the triggering element (e.g. a radio button)
export default class extends Controller {
  static targets = ["container", "count", "age", "field", "template"]
  static values = { initial: Array }

  connect() {
    this.rebuild()
  }

  rebuild() {
    let ages = this.initialValue

    this.containerTarget.textContent = ""

    if (this.countTarget.value > 0) {
      for (let i = 0; i < this.countTarget.value; i++) {
        // clone
        let field = this.templateTarget.content.firstElementChild.cloneNode(true)

        // per child label
        let label = field.querySelector("label")
        label.textContent = "Age of child " + (i + 1)

        // configure select for array, with initial value
        let select = field.querySelector("select")
        select.name += "[]"
        select.value = ages[i]

        // add to container
        this.containerTarget.appendChild(field)
      }
    }
  }

  update() {
    this.initialValue = this.ageTargets
      .map((element) => parseInt(element.value))
      .filter((value) => Number.isInteger(value))
  }
}
